const Bank = () =>
  import(
    /* webpackChunkName: "base-info-financial-bank" */ '@/pages/base-info/financial/bank/index.vue'
  )
const CreateBank = () =>
  import(
    /* webpackChunkName: "base-info-financial-bank" */ '@/pages/base-info/financial/bank/create.vue'
  )
const EditBank = () =>
  import(
    /* webpackChunkName: "base-info-financial-bank" */ '@/pages/base-info/financial/bank/edit.vue'
  )

export default {
  path: 'bank',
  meta: {
    label: 'bank',
    auth: 'bank'
  },
  component: {
    name: 'Bank',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoFinancialBank',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Bank
    },
    {
      name: 'BaseInfoCreateFinancialBank',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateBank
    },
    {
      name: 'BaseInfoEditFinancialBank',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditBank,
      props: true
    }
  ]
}
